import { render, staticRenderFns } from "./CheckboxRichText.vue?vue&type=template&id=df095cdc&"
import script from "./CheckboxRichText.vue?vue&type=script&lang=js&"
export * from "./CheckboxRichText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports